import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";
import { memo } from "react";

const StatisticalIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 111 41"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      className={className}
      {...otherProps}
    >
      <rect y="19" width="3" height="22" fill="currentColor" />
      <rect x="6" y="6" width="3" height="35" fill="currentColor" />
      <rect x="12" y="13" width="3" height="28" fill="currentColor" />
      <rect x="18" y="19" width="3" height="22" fill="currentColor" />
      <rect x="24" y="13" width="3" height="28" fill="currentColor" />
      <rect x="30" y="6" width="3" height="35" fill="currentColor" />
      <rect x="36" width="3" height="41" fill="currentColor" />
      <rect x="42" y="8" width="3" height="33" fill="currentColor" />
      <rect x="48" y="13" width="3" height="28" fill="currentColor" />
      <rect x="54" y="19" width="3" height="22" fill="currentColor" />
      <rect x="60" y="26" width="3" height="15" fill="currentColor" />
      <rect x="66" y="23" width="3" height="18" fill="currentColor" />
      <rect x="72" y="13" width="3" height="28" fill="currentColor" />
      <rect x="78" y="19" width="3" height="22" fill="currentColor" />
      <rect x="84" y="27" width="3" height="14" fill="currentColor" />
      <rect x="90" y="31" width="3" height="10" fill="currentColor" />
      <rect x="96" y="33" width="3" height="8" fill="currentColor" />
      <rect x="102" y="31" width="3" height="10" fill="currentColor" />
      <rect x="108" y="23" width="3" height="18" fill="currentColor" />
    </SvgIcon>
  );
};

export default memo(StatisticalIcon);
